
export const distanceFunc = (mycoords, distancecoords) => {
  let dx = 71.5 * (mycoords.lng.toFixed(3) - distancecoords.lng.toFixed(3))
  let dy = 111.3 * (mycoords.lat.toFixed(3) - distancecoords.lat.toFixed(3))

  let distance  = (Math.sqrt(dx * dx + dy * dy))
  
  let calcDistance

  if (distance < 10) {
    calcDistance = distance
  } else if (distance < 20) {
    calcDistance = (distance + 2.2)
  } else if (distance < 30) {
    calcDistance = (distance + (2 * 2.2))
  } else if (distance < 40) {
    calcDistance = (distance + (3 * 2.2))
  } else if (distance < 50) {
    calcDistance = (distance + (4 * 2.2))
  } else {
    calcDistance = (distance + (5 * 2.2))
  }

  return { distance, calcDistance }
}